module.exports = __webpack_public_path__ + "media/hyper/images/layouts/layout-2-f9358e1ac287c04faf0f855f12b55d51.png";